module.exports = __webpack_public_path__ + "img/box7-1-1.b34e23c4.png";